import { Navigate, useLocation } from 'react-router';
import { loginPathReturningTo } from 'src/auth/utils/returnTo';

export const redirectToLogin = ({ returnToPage = true }: { returnToPage?: boolean } = {}) => {
  if (!returnToPage) {
    window.location.replace('/login');
    return;
  }
  const { pathname, search, hash } = window.location;
  window.location.replace(loginPathReturningTo(`${pathname}${search}${hash}`));
};

export const RedirectToLoginPage = () => {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={loginPathReturningTo(`${pathname}${search}${hash}`)} replace />;
};
